import { render, staticRenderFns } from "./mGFLOLDan.vue?vue&type=template&id=65ce08dc&scoped=true"
import script from "./mGFLOLDan.vue?vue&type=script&lang=js"
export * from "./mGFLOLDan.vue?vue&type=script&lang=js"
import style0 from "./mGFLOLDan.vue?vue&type=style&index=0&id=65ce08dc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce08dc",
  null
  
)

export default component.exports